<template>
  <div v-loading="loading" class="app_download_qrcode">
    <template v-if="detailData">
      <img :width="imageSize" :src="getQrCodeUrl(detailData.appDownloadUrl)" />
      <div v-if="detailData.appVersionCode" style="margin-bottom: 10px">
        版本号：{{ detailData.appVersionCode }}
      </div>
    </template>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.app_download_qrcode {
  text-align: center;
}
</style>

<script>
export default {
  props: {
    imageSize: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      detailData: null,
    }
  },
  methods: {
    getDetail() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("api.system.global.setting.detail", {
        settingKey: "system_global_app_update_config"
      }).then((resp) => {
        let settingValue = this.toAny(resp.data.settingValue, {});
        if (settingValue && settingValue.appDownloadUrl) {
          this.detailData = settingValue;
        } else {
          throw new Error("未上传APP客户端安装包")
        }
      }).catch((err) => {
        this.errorMsg = (err && (err.msg || err.message))
          || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getDetail();
  }
}
</script>